.loadingScreen {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}
